// Import cloud provider icons from DataSourceIcons
import {
  CROWDSTRIKE,
  CROWDSTRIKE_DARK,
  ECR,
  AMAZON_ECR_DARK,
  AWS,
  AWS_DARK,
  SAP,
  GCP,
  GCP_DARK,
  AZURE,
  OKTA,
  GOOGLECONTAINERREGISTRY,
  ELASTICCLOUDSECURITY,
  ELASTIC_CLOUD_SECURITY_DARK,
  ACR,
  GIT,
  GIT_DARK,
  GITLAB_SCA,
  GITLAB_DARK,
  HARBOR,
  HARBOR_DARK,
  JFROGCONTAINERREGISTRY,
  NEXUS,
  NEXUS_DARK,
  REDHAT,
  REDHAT_DARK,
  HASHICORP,
  HASHICORP_DARK,
  JFROG,
  JFROG_DARK,
  GITHUBACTIONS,
  DOCKER,
  BITBUCKET,
  MONITOR,
  MONITOR_DARK,
  Cloud,
  CodeRepository,
  JIRA,
  JIRA_DARK,
  BOX,
  SALESFORCE,
  SLACK,
  SLACK_DARK,
  EMAIL,
  EMAIL_DARK,
  TEAMS,
  OFFICE365,
  SNOWFLAKE,
  CONFLUENCE,
  MONDAY,
  MONDAY_DARK,
  SERVICENOW,
  SERVICENOW_DARK,
  IVANTI,
  IVANTI_DARK,
  SHAREPOINT,
  INTUNE,
  KUBERNETES,
  ZOOM,
  SONATYPE,
  SONATYPE_DARK,
  JIRA as JIRA_ON_PREM,
  Datacenter,
  KUBERNETES_DARK,
  INTUNE_DARK,
} from "../DataSourceIcons/DataSourceIcons";

// Import cloud provider icons from CloudProviderIcons
import {
  ABNORMALAI,
  ABNORMALAI_DARK,
  ASANA,
  ASANA_DARK,
  ATLAS,
  ATLAS_DARK,
  AZURE_DARK,
  BITBUCKET_DARK,
  BOX_DARK,
  NOTION,
  NOTION_DARK,
  TABLEAU,
  TABLEAU_DARK,
  TRELLO,
  TRELLO_DARK,
  JENKINS,
  JENKINS_DARK,
  CIRCLECI,
  CIRCLECI_DARK,
  CLOUDEXTERNAL_DARK,
  CODEREPOSITORY_DARK,
  CONFLUENCE_DARK,
  DATACENTER_DARK,
  DATADOG,
  DATADOG_DARK,
  DEFAULT as DEFAULT_CLOUD_PROVIDER,
  DEFAULT_DARK,
  DOCKER_DARK,
  DOCUSIGN,
  DOCUSIGN_DARK,
  GOOGLEWORKSPACE,
  GOOGLEWORKSPACE_DARK,
  LUCIDCHART,
  LUCIDCHART_DARK,
  OCI,
  OCI_DARK,
  PAGERDUTY,
  PAGERDUTY_DARK,
  QUAYIO,
  QUAYIO_DARK,
  SMARTSHEET,
  SMARTSHEET_DARK,
  STACKIT,
  STACKIT_DARK,
  ZSCALER,
  ZSCALER_DARK,
} from "./CloudProviderIcons";

export const cloudProviderIcons: Record<
  string,
  { LIGHT: string; DARK?: string | null }
> = {
  abnormal_ai: {
    LIGHT: ABNORMALAI,
    DARK: ABNORMALAI_DARK,
  },
  crowdstrike: {
    LIGHT: CROWDSTRIKE,
    DARK: CROWDSTRIKE_DARK,
  },
  amazon_ecr: {
    LIGHT: ECR,
    DARK: AMAZON_ECR_DARK,
  },
  aws: {
    LIGHT: AWS,
    DARK: AWS_DARK,
  },
  sap: {
    LIGHT: SAP,
    DARK: SAP,
  },
  asana: {
    LIGHT: ASANA,
    DARK: ASANA_DARK,
  },
  atlas: {
    LIGHT: ATLAS,
    DARK: ATLAS_DARK,
  },
  notion: {
    LIGHT: NOTION,
    DARK: NOTION_DARK,
  },
  tableau: {
    LIGHT: TABLEAU,
    DARK: TABLEAU_DARK,
  },
  trello: {
    LIGHT: TRELLO,
    DARK: TRELLO_DARK,
  },
  code_repository: {
    LIGHT: CodeRepository,
    DARK: CODEREPOSITORY_DARK,
  },
  gcp: {
    LIGHT: GCP,
    DARK: GCP_DARK,
  },
  azure: {
    LIGHT: AZURE,
    DARK: AZURE_DARK,
  },
  ecr: {
    LIGHT: ECR,
    DARK: AMAZON_ECR_DARK,
  },
  okta: {
    LIGHT: OKTA,
    DARK: OKTA,
  },
  aws_ecr: {
    LIGHT: ECR,
    DARK: AMAZON_ECR_DARK,
  },
  google_container_registry: {
    LIGHT: GOOGLECONTAINERREGISTRY,
    DARK: null,
  },
  elastic: {
    LIGHT: ELASTICCLOUDSECURITY,
    DARK: ELASTIC_CLOUD_SECURITY_DARK,
  },
  microsoft_container_registry: {
    LIGHT: ACR,
    DARK: ACR,
  },
  azure_container_registry: {
    LIGHT: ACR,
    DARK: ACR,
  },
  acr: {
    LIGHT: ACR,
    DARK: ACR,
  },
  github: {
    LIGHT: GIT,
    DARK: GIT_DARK,
  },
  git_hub: {
    LIGHT: GIT,
    DARK: GIT_DARK,
  },
  git_hub_container_registry: {
    LIGHT: GIT,
    DARK: GIT_DARK,
  },
  github_container_registry: {
    LIGHT: GIT,
    DARK: GIT_DARK,
  },
  gitlab: {
    LIGHT: GITLAB_SCA,
    DARK: GITLAB_DARK,
  },
  git_lab: {
    LIGHT: GITLAB_SCA,
    DARK: GITLAB_DARK,
  },
  git_lab_container_registry: {
    LIGHT: GITLAB_SCA,
    DARK: GITLAB_DARK,
  },
  gitlab_container_registry: {
    LIGHT: GITLAB_SCA,
    DARK: GITLAB_DARK,
  },
  harbor_container_registry: {
    LIGHT: HARBOR,
    DARK: HARBOR_DARK,
  },
  j_frog_container_registry: {
    LIGHT: JFROGCONTAINERREGISTRY,
    DARK: JFROGCONTAINERREGISTRY,
  },
  nexus_container_registry: {
    LIGHT: NEXUS,
    DARK: NEXUS_DARK,
  },
  red_hat_container_registry: {
    LIGHT: REDHAT,
    DARK: REDHAT_DARK,
  },
  hashicorp_vault: {
    LIGHT: HASHICORP,
    DARK: HASHICORP_DARK,
  },
  jenkins: {
    LIGHT: JENKINS,
    DARK: JENKINS_DARK,
  },
  circleci: {
    LIGHT: CIRCLECI,
    DARK: CIRCLECI_DARK,
  },
  j_frog: {
    LIGHT: JFROG,
    DARK: JFROG_DARK,
  },
  github_actions: {
    LIGHT: GITHUBACTIONS,
    DARK: GITHUBACTIONS,
  },
  datacenter: {
    LIGHT: Datacenter,
    DARK: DATACENTER_DARK,
  },
  on_prem: {
    LIGHT: Datacenter,
    DARK: DATACENTER_DARK,
  },
  docker_hub: {
    LIGHT: DOCKER,
    DARK: DOCKER_DARK,
  },
  g_suite: {
    LIGHT: GOOGLEWORKSPACE,
    DARK: GOOGLEWORKSPACE_DARK,
  },
  google: {
    LIGHT: GOOGLEWORKSPACE,
    DARK: GOOGLEWORKSPACE_DARK,
  },
  google_workspace: {
    LIGHT: GOOGLEWORKSPACE,
    DARK: GOOGLEWORKSPACE_DARK,
  },
  cross_system: {
    LIGHT: CodeRepository,
    DARK: CODEREPOSITORY_DARK,
  },
  bitbucket_cloud: {
    LIGHT: BITBUCKET,
    DARK: BITBUCKET_DARK,
  },
  desktop_management: {
    LIGHT: MONITOR,
    DARK: MONITOR_DARK,
  },
  manual: {
    LIGHT: Cloud,
    DARK: CLOUDEXTERNAL_DARK,
  },
  external: {
    LIGHT: Cloud,
    DARK: CLOUDEXTERNAL_DARK,
  },
  other: {
    LIGHT: CodeRepository,
    DARK: CODEREPOSITORY_DARK,
  },
  bitbucket: {
    LIGHT: BITBUCKET,
    DARK: BITBUCKET_DARK,
  },
  jira: {
    LIGHT: JIRA,
    DARK: JIRA_DARK,
  },
  box: {
    LIGHT: BOX,
    DARK: BOX_DARK,
  },
  salesforce: {
    LIGHT: SALESFORCE,
    DARK: SALESFORCE,
  },
  slack: {
    LIGHT: SLACK,
    DARK: SLACK_DARK,
  },
  email: {
    LIGHT: EMAIL,
    DARK: EMAIL_DARK,
  },
  teams: {
    LIGHT: TEAMS,
    DARK: TEAMS,
  },
  zscaler: {
    LIGHT: ZSCALER,
    DARK: ZSCALER_DARK,
  },
  office_365: {
    LIGHT: OFFICE365,
    DARK: OFFICE365,
  },

  m_365: {
    LIGHT: OFFICE365,
    DARK: OFFICE365,
  },

  microsoft_365: {
    LIGHT: OFFICE365,
    DARK: OFFICE365,
  },

  snowflake: {
    LIGHT: SNOWFLAKE,
    DARK: SNOWFLAKE,
  },
  confluence: {
    LIGHT: CONFLUENCE,
    DARK: CONFLUENCE_DARK,
  },
  monday: {
    LIGHT: MONDAY,
    DARK: MONDAY_DARK,
  },
  datadog: {
    LIGHT: DATADOG,
    DARK: DATADOG_DARK,
  },
  service_now: {
    LIGHT: SERVICENOW,
    DARK: SERVICENOW_DARK,
  },
  ivanti: {
    LIGHT: IVANTI,
    DARK: IVANTI_DARK,
  },
  github_issues: {
    LIGHT: GIT,
    DARK: GIT_DARK,
  },
  share_point_one_drive: {
    LIGHT: SHAREPOINT,
    DARK: SHAREPOINT,
  },
  intune: {
    LIGHT: INTUNE,
    DARK: INTUNE_DARK,
  },
  kubernetes: {
    LIGHT: KUBERNETES,
    DARK: KUBERNETES_DARK,
  },
  kubernetes_container_image_registry: {
    LIGHT: KUBERNETES,
    DARK: KUBERNETES_DARK,
  },
  zoom: {
    LIGHT: ZOOM,
    DARK: ZOOM,
  },
  docu_sign: {
    LIGHT: DOCUSIGN,
    DARK: DOCUSIGN_DARK,
  },
  smartsheet: {
    LIGHT: SMARTSHEET,
    DARK: SMARTSHEET_DARK,
  },
  stackit: {
    LIGHT: STACKIT,
    DARK: STACKIT_DARK,
  },
  goriv: {
    LIGHT: DEFAULT_CLOUD_PROVIDER,
    DARK: DEFAULT_DARK,
  },
  pager_duty: {
    LIGHT: PAGERDUTY,
    DARK: PAGERDUTY_DARK,
  },
  lucidchart: {
    LIGHT: LUCIDCHART,
    DARK: LUCIDCHART_DARK,
  },
  sonatype: {
    LIGHT: SONATYPE,
    DARK: SONATYPE_DARK,
  },
  unknown: {
    LIGHT: DEFAULT_CLOUD_PROVIDER,
    DARK: DEFAULT_DARK,
  },
  jira_on_prem: {
    LIGHT: JIRA_ON_PREM,
    DARK: JIRA_DARK,
  },
  quay_io_container_registry: {
    LIGHT: QUAYIO,
    DARK: QUAYIO_DARK,
  },
  quay: {
    LIGHT: QUAYIO,
    DARK: QUAYIO_DARK,
  },
  quey: {
    LIGHT: QUAYIO,
    DARK: QUAYIO_DARK,
  },
  quey_io: {
    LIGHT: QUAYIO,
    DARK: QUAYIO_DARK,
  },
  oci: {
    LIGHT: OCI,
    DARK: OCI_DARK,
  },
  jfrog: {
    LIGHT: JFROG,
    DARK: JFROG_DARK,
  },
  jfrog_container_registry: {
    LIGHT: JFROG,
    DARK: JFROG_DARK,
  },
};
